import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "speaker-detail-dialog"
}
const _hoisted_2 = {
  class: "speaker-detail-dialog-container",
  ref: "container"
}
const _hoisted_3 = { class: "close-button" }
const _hoisted_4 = { class: "speaker-detail-container" }
const _hoisted_5 = { class: "speaker-logo" }
const _hoisted_6 = { class: "speaker-detail-infos" }
const _hoisted_7 = { class: "speaker-name" }
const _hoisted_8 = { class: "speaker-position" }
const _hoisted_9 = { class: "speaker-company" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "speaker-infos" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "speaker-speeches" }
const _hoisted_15 = { class: "speech" }
const _hoisted_16 = { class: "speech-date" }
const _hoisted_17 = { class: "speech-content" }
const _hoisted_18 = { class: "speech-title" }
const _hoisted_19 = { class: "speech-footer" }
const _hoisted_20 = { class: "speech-time-container" }
const _hoisted_21 = { class: "speech-place" }
const _hoisted_22 = { class: "speech-language" }
const _hoisted_23 = {
  key: 0,
  class: "speech-translation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
            }, "X")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                style: _normalizeStyle([_ctx.speaker.hasPicture() ? {'background-image':'url('+ _ctx.speaker.getPictureUrl()+')'} : {} ])
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.speaker.displayName), 1),
              _createElementVNode("small", _hoisted_8, _toDisplayString(_ctx.speaker.position), 1),
              _createElementVNode("small", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.speaker.company), 1),
                (_ctx.speaker.country)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      (_ctx.speaker.company)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, ","))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.speaker.country), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.speaker.info)
              ? (_openBlock(), _createElementBlock("small", {
                  key: 0,
                  class: "infos",
                  innerHTML: _ctx.speaker.info
                }, null, 8, _hoisted_13))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speeches, (speech) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: "speech-header",
                  style: _normalizeStyle(_ctx.getHeaderStyle(speech))
                }, [
                  (speech.category)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "speech-category",
                        style: _normalizeStyle(_ctx.getColorCSS(speech))
                      }, _toDisplayString(speech.category), 5))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(speech.startDate), 1)
                ], 4),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(speech.title), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-clock" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(speech.timeSpan), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(speech.place), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-comment-alt-lines" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.getLangForSpeechById(speech.languageID)), 1)
                  ]),
                  (speech.hasTranslation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-headphones-alt" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('translate')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 256))
          ])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}